import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import useGet from "../../../global/hooks/useGet";
import { GlobalTable } from "../../../global/components/GlobalTable";
// import { DeviceColumns } from "./Columns";
import ConfirmModal from "../../../global/components/ConfirmModal";
import useDelete from "../../../global/hooks/useDelete";
import {
  openConfirmNotification,
  openErrorNotification,
} from "../../../global/utils/toast";
import CommonBreadcrumb from "../../../global/components/CommonBreadcrumb";
import { MySiteFilter } from "../Components/FilterComponent";
import { MysiteColumns } from "./Columns";
import { SiteBlockedModal } from "../Components/SiteBlockedModal";
import { getUserRole, hasRole, getUserData } from "../../../global/hooks/getUserRole";
import axios from "axios";

const initialFilterState = {
  DeviceNo: "",
  DeviceName: "",
  Description: "",
  SiteType: null,
  OemNo: null,
  DealerNo: null,
  CustomerNo: null,
  Mac: "",
  Version: "",
  Address: "",
  Online: null,
  RMC: null,
  Favorite: null,
};

export const MySite = () => {
  const [listData, setListData] = useState([]);
  const [modal, setModal] = useState(null);
  const [params, setParams] = useSearchParams({
    limit: 10,
    sort_by: "DeviceNo",
    order: "desc",
    // NodeType: "1",
  });

  const modParams = { ...Object.fromEntries([...params?.entries()]) } || {}; //
  const initialPagination = {
    current: parseInt(modParams.page) || 1,
    pageSize: parseInt(modParams.limit) || 10,
    total: 0,
  }; //
  const [pagination, setPagination] = useState(initialPagination);
  const [filter, setFilter] = useState(initialFilterState);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [filterNoValueText, setFilterNoValueText] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [columnsValues, setColumnsValues] = useState([]);
  const [resetTrigger, setResetTrigger] = useState(false);
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);
  const [childSitesByParent, setChildSitesByParent] = useState({});
  const [childLoadingByParent, setChildLoadingByParent] = useState({});

  const navigate = useNavigate();
  const userData = getUserData();
  const accessToken = userData?.access_token || null;

  const breadcrumbItems = [
    {
      label: "Site",
      href: "/site",
    },
  ];

  // to get table data from API server
  const query = new URLSearchParams(params);
  // Remove unwanted keys
  query.delete("pageSize");
  query.delete("total");
  query.delete("current");
  const updatedQuery = query.toString();

  const url = updatedQuery
    ? `${process.env.REACT_APP_API_URL}/api/sites/?${updatedQuery}`
    : `${process.env.REACT_APP_API_URL}/api/sites/`;
  const { data, loading, error, refetch } = useGet(url);

  let deleteUrl;
  deleteUrl = `${process.env.REACT_APP_API_URL}/api/sites/bulk-delete/`;

  const {
    data: deletedData,
    loading: deletedDataLoading,
    error: deletedDataError,
    deleteMultiple,
  } = useDelete(deleteUrl);

  useEffect(() => {
    const matchedFilter = {};
    for (const key in initialFilterState) {
      if (modParams[key] !== undefined) {
        matchedFilter[key] = modParams[key];
      }
    }

    setFilter((prev) => ({
      ...prev,
      ...matchedFilter,
    }));
  }, []); //

  const paginationConfig = {
    current: pagination.current,
    pageSize: pagination.pageSize,
    total: data?.count,
    showSizeChanger: true,
    pageSizeOptions: [10, 20, 50, 100],
    showTotal: (total, range) => `Total ${total} items ${range[0]}-${range[1]}`,
    onChange: (page, pageSize) => {
      setPagination({
        ...pagination,
        current: page,
        pageSize: pageSize,
      });

      const updatedParams = {
        ...Object.fromEntries([...params.entries()]),
        limit: pageSize,
        page: page,
      };
      setParams(updatedParams);
    },
  };

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
    // navigate(`/oemlist/${newSelectedRowKeys}`);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
    fixed: true,
    columnWidth: 40,
  };
  const canSelectRows = [1, 2, 3, 7, 8, 9].includes(getUserRole());

  const onRow = (record) => {
    return {
      onClick: (event) => {
        navigate(`/site/info/${record?.DeviceNo}`);
      },
    };
  };

  const handleFilterChange = (e) => {
    const inputName = e.target.name;
    const inputValue = e.target.value.replace(/['""`''""]/g, "");
    setFilter({ ...filter, [inputName]: inputValue });
  };

  const handleFilter = (e) => {
    const filterDict = {};
    for (const key in filter) {
      if (
        filter[key] !== null &&
        filter[key] !== "" &&
        filter[key] !== undefined
      ) {
        filterDict[key] = filter[key];
      }
    }
    const isEmpty = JSON.stringify(filterDict) === "{}";
    if (isEmpty) {
      setFilterNoValueText("No value exists!");
      handleReset();
    } else {
      const modParams = { ...Object.fromEntries([...params?.entries()]) } || {}; //

      const tempParams = {
        // ...modParams,
        ...filterDict,
        limit: pagination.pageSize,
        sort_by: modParams.sort_by,
        order: modParams.order,
        page: 1,
        // NodeType: "1",
      };
      setPagination((prev) => ({ ...prev, current: 1 }));
      setParams(tempParams);
      refetch();
    }
  };

  // reset
  const handleReset = (e) => {
    // Reset the filter state to the initial state
    setFilter({
      current: 1,
      pageSize: 10,
      total: 0,
    }); //
    setPagination({
      current: 1,
      pageSize: 10,
      total: 0,
    }); //
    // Define the new parameters for the API call
    const params = {
      limit: 10,
      sort_by: "DeviceNo", // Make sure to specify sorting if necessary
      order: "desc",
      // NodeType: "1",
    };

    // Update the parameters in the state
    setParams(params);
    refetch();
    setSelectedRowKeys([]);
    setResetTrigger(!resetTrigger);
  };

  const onDeleteConfirm = async () => {
    try {
      await deleteMultiple({ ids: selectedRowKeys });
    } catch (error) {
      openErrorNotification("Something went wrong.");
    }
    setShowModal(false);
    setSelectedRowKeys([]);
  };

  useEffect(() => {
    if (deletedData && !deletedDataError) {
      openConfirmNotification("Success");
      refetch();
    } else if (deletedDataError) {
      openErrorNotification(
        deletedDataError?.response?.data?.message || "Something went wrong",
      );
    }
  }, [deletedData, deletedDataError]);

  useEffect(() => {
    if (data && !loading) {
      const newData = data?.data?.map((el) => ({
        ...el,
        key: el?.DeviceNo,
      }));
      setListData(newData);
    }
  }, [data, loading]);

  const fetchChildSites = async (record) => {
    const parentKey = record?.DeviceNo;
    if (parentKey == null) return;
    if (Array.isArray(childSitesByParent[parentKey])) return;

    const serverDeviceNo = record?.DeviceNo;
    if (serverDeviceNo == null) {
      setChildSitesByParent((prev) => ({ ...prev, [parentKey]: [] }));
      return;
    }

    setChildLoadingByParent((prev) => ({ ...prev, [parentKey]: true }));
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/sites/client-list/?ServerDeviceNo=${serverDeviceNo}`,
        {
          headers: {
            "Content-Type": "application/json",
            ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
          },
          timeout: 15000,
        },
      );
      const childRows = Array.isArray(response?.data?.data)
        ? response.data.data
        : Array.isArray(response?.data)
          ? response.data
          : [];
      setChildSitesByParent((prev) => ({
        ...prev,
        [parentKey]: childRows.map((el) => ({
          ...el,
          key: `${parentKey}-${el?.DeviceNo ?? Math.random()}`,
        })),
      }));
    } catch (err) {
      setChildSitesByParent((prev) => ({ ...prev, [parentKey]: [] }));
      openErrorNotification("Failed to load client nodes.");
    } finally {
      setChildLoadingByParent((prev) => ({ ...prev, [parentKey]: false }));
    }
  };

  const toggleClientNodes = async (record) => {
    const parentKey = record?.DeviceNo;
    if (parentKey == null) return;
    const isExpanded = expandedRowKeys.includes(parentKey);
    if (isExpanded) {
      setExpandedRowKeys((prev) => prev.filter((k) => k !== parentKey));
      return;
    }
    setExpandedRowKeys((prev) => [...prev, parentKey]);
    await fetchChildSites(record);
  };

  const mainColumns = MysiteColumns(
    null,
    setShowModal,
    setSelectedRowKeys,
    setParams,
    params,
    setModal,
    columnsValues,
  );

  const childColumns = [
    { title: "No", dataIndex: "DeviceNo", key: "DeviceNo", width: 80 },
    {
      title: "Device Name",
      dataIndex: "DeviceName",
      key: "DeviceName",
      width: 160,
    },
    { title: "Desc", dataIndex: "DeviceDesc", key: "DeviceDesc", width: 150 },
    ...(hasRole(1, 2, 3)
      ? [{ title: "OEM", dataIndex: "OemName", key: "OemName", width: 140 }]
      : []),
    ...(hasRole(1, 2, 3, 4, 5, 6)
      ? [
          {
            title: "Dealer",
            dataIndex: "DealerName",
            key: "DealerName",
            width: 140,
          },
        ]
      : []),
    {
      title: "Customer",
      dataIndex: "CustomerName",
      key: "CustomerName",
      width: 140,
    },
    { title: "Site Type", dataIndex: "SiteType", key: "SiteType", width: 130 },
    { title: "MAC", dataIndex: "Mac", key: "Mac", width: 150 },
    { title: "Product", dataIndex: "Product", key: "Product", width: 150 },
    { title: "Version", dataIndex: "Version", key: "Version", width: 120 },
    { title: "Micom", dataIndex: "Micom", key: "Micom", width: 120 },
    { title: "Address", dataIndex: "Address", key: "Address", width: 120 },
    // { title: "Product", dataIndex: "Product", key: "Product", width: 120 },
    // { title: "Model", dataIndex: "Model", key: "Model", width: 120 },
    // {
    //   title: "Door",
    //   dataIndex: "Type",
    //   key: "Type",
    //   width: 90,
    // },
    {
      title: "",
      dataIndex: "",
      key: "",
      width: 1,
    },
  ];

  return (
    <div>
      <div className="pb-4 -mt-4 pt-[6px]">
        <CommonBreadcrumb breadcrumbItems={breadcrumbItems} />
      </div>
      <div className="p-4 bg-white rounded-[4px] border border-gray-200">
        <MySiteFilter
          filter={filter}
          handleFilterChange={handleFilterChange}
          handleFilter={handleFilter}
          handleReset={handleReset}
          setShowModal={setShowModal}
          selectedRowKeys={selectedRowKeys}
          setFilter={setFilter}
          data={data}
          setColumnsValues={setColumnsValues}
        />
        <ConfirmModal
          showModal={showModal}
          setShowModal={setShowModal}
          onDeleteConfirm={onDeleteConfirm}
          setSelectedRowKeys={setSelectedRowKeys}
        />
        <div className="mt-4 mysite-expand-icon">
          <GlobalTable
            columns={mainColumns}
            dataSource={listData}
            rowSelection={canSelectRows ? rowSelection : null}
            pagination={paginationConfig}
            onRow={(record, rowIndex) => {
              return {
                ...onRow?.(record, rowIndex),
              };
            }}
            loading={loading}
            tableProps={{
              rowClassName: () => "mysite-parent-row",
            }}
            expandable={{
              expandedRowKeys,
              rowExpandable: (record) => Boolean(record?.HasClientSite),
              expandedRowRender: (record) => {
                const parentKey = record?.DeviceNo;
                const childRows = childSitesByParent[parentKey] || [];
                const childLoading = !!childLoadingByParent[parentKey];
                return (
                  <div className="pl-8 pr-2 py-1">
                    <GlobalTable
                      columns={childColumns}
                      dataSource={childRows}
                      pagination={false}
                      loading={childLoading}
                      loaderRowCount={5}
                      onRow={(childRecord) => ({
                        onClick: () =>
                          navigate(`/site/info/${childRecord?.DeviceNo}`),
                      })}
                      tableProps={{ size: "small" }}
                    />
                  </div>
                );
              },
              onExpand: (expanded, record) => {
                if (!expanded) {
                  const parentKey = record?.DeviceNo;
                  if (parentKey != null) {
                    setExpandedRowKeys((prev) =>
                      prev.filter((k) => k !== parentKey),
                    );
                  }
                  if (
                    typeof document !== "undefined" &&
                    document.activeElement instanceof HTMLElement
                  ) {
                    document.activeElement.blur();
                  }
                  return;
                }
                if (!record?.HasClientSite) return;
                toggleClientNodes(record);
              },
              expandIconColumnIndex: canSelectRows ? 1 : 0,
              columnWidth: 40,
            }}
            resize
            resetTrigger={resetTrigger}
          />
        </div>
      </div>
      <SiteBlockedModal
        isModalOpen={modal !== null}
        setModal={setModal}
        modal={modal}
      />
    </div>
  );
};
